/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import SuccessStories from "./SuccessStories";

export default SuccessStories;
